import { CardEndpoint } from "@/views/loyalty/shared/endpoint_services/card-endpoint-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"

export class CardService {
    constructor () {
        this.cardEndpoint = new CardEndpoint()
    }

    async getCard (item) {
        return this.cardEndpoint.get_card(item)
    }

    async getCards (page, limit, filter, search) {
        return this.cardEndpoint.get_cards(page, limit, filter, search || SearchStuffModel)
    }
}
